<div class="file-upload-box alert-dismissible" *ngIf="isFileUploadBoxVisible()">
  <div class="file-info-container">
    <span class="file-info" title="{{ getFileInfo().file.name }}">
      <i class="file-upload-icon fa {{ getFileInfo().fileIcon }}"></i>
      {{ getFileInfo().file.name }}
    </span>
    <button (click)="sendFileHandler()" *ngIf="fileSharingService.isFileUploaded(workItemId)" class="btn bc-footer-button js-send-file-button send-file-button btn-dark" title="">
      <span>{{ 'bcEmailBox.sendButton' | translate }}</span>
    </button>
    <span class="uploading-file" *ngIf="!fileSharingService.isFileUploaded(workItemId)"> {{ 'fileUploadBox.uploadingText' | translate: { size: getFileInfo().fileSize } }}</span>
  </div>
  <a class="cancel-upload-link" (click)="closeHandler()">
    <svg-icon icon="x"></svg-icon>
  </a>
</div>
<div class="file-upload-progress" *ngIf="isFileUploadInProgress()" [ngStyle]="{width: getFileInfo().progress + '%'}"></div>

<div class="file-upload-box file-error-box alert-dismissible" *ngIf="fileSharingService.hasErrorMessage(workItemId)">
  <div class="file-info" title="{{ getFileInfo().file.name }}">
    <svg-icon class="alert-icon" icon="alert"></svg-icon>
    <i class="file-upload-icon fa {{ getFileInfo().fileIcon }}"></i>
    {{ getFileInfo().file.name }}
  </div>
  <div class="error-message">{{ 'fileUploadBox.errorMessage' | translate }}</div>
  <a class="cancel-upload-link" (click)="closeHandler()">
    <svg-icon icon="x"></svg-icon>
  </a>
</div>
